import { render, staticRenderFns } from "./AiBuddyButton.vue?vue&type=template&id=e1826b52&scoped=true"
import script from "./AiBuddyButton.vue?vue&type=script&lang=js"
export * from "./AiBuddyButton.vue?vue&type=script&lang=js"
import style0 from "./AiBuddyButton.vue?vue&type=style&index=0&id=e1826b52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1826b52",
  null
  
)

export default component.exports